import React, { useState } from "react";

import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";

import InputMask from "react-input-mask";

import {
  formatExpirationDate,
  formatCVC,
  formatCardNumber,
} from "../../utils/paymentUtil";

function InvoicePage() {
  InvoicePage.propTypes = {};

  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");
  const [focus, setFocus] = useState("");
  const [name, setName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [issuer, setIssuer] = useState("");

  const [phone, setPhone] = useState("");

  const handleExpiryChange = ({ target }) => {
    if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    }
    setExpiry(target.value);
  };

  const handleCvcChange = ({ target }) => {
    if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    }
    setCvc(target.value);
  };

  const handleCardNumberChange = ({ target }) => {
    if (target.name === "cardNumber") {
      target.value = formatCardNumber(target.value);
    }
    setCardNumber(target.value);
  };

  const handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      setIssuer(issuer);
    }
  };

  const handleChangePhone = ({ target }) => {
    setPhone(target.value);
  };

  return (
    <div>
      <h1> Deneme Page </h1>
      <div className="form-group">
        <InputMask
          mask="99/99/99"
          maskPlaceholder="dd/mm/yy"
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="form-group">
        <InputMask
          value={phone}
          onChange={handleChangePhone}
          mask="(599) 999 99 99"
          maskChar="_"
        />
      </div>

      <div className="form-group">
        {phone}
        </div>

      <div className="form-group">
        <InputMask
            id="expiry"
            name="expiry"
          value={expiry}
          onChange={handleExpiryChange}
          mask="99 / 99"
          maskChar="_"
        />
      </div>

      <div className="form-group">
        {expiry}
        </div>

      <div id="PaymentForm">
        <Cards
          number={cardNumber}
          name={name}
          expiry={expiry}
          cvc={cvc}
          focused={focus}
          callback={handleCallback}
        />
        <form>
          <div className="form-group">
            <input
              type="tel"
              name="cardNumber"
              className="form-control"
              placeholder="Card Number"
              pattern="[\d| ]{16,22}"
              required
              onChange={handleCardNumberChange}
              onFocus={(e) => setFocus(e.target.name)}
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Name"
              required
              onChange={(e) => setName(e.target.value)}
              onFocus={(e) => setFocus(e.target.name)}
            />
          </div>
          <div className="row">
            <div className="col-6">
              <input
                type="tel"
                name="expiry"
                className="form-control"
                placeholder="Valid Thru"
                pattern="\d\d/\d\d"
                required
                onChange={handleExpiryChange}
                onFocus={(e) => setFocus(e.target.name)}
              />
            </div>

            <div className="col-6">
              <input
                type="tel"
                name="cvc"
                className="form-control"
                placeholder="CVC"
                pattern="\d{3,4}"
                required
                onChange={handleCvcChange}
                onFocus={(e) => setFocus(e.target.name)}
                onBlur={(e) => setFocus("name")}
              />
            </div>
          </div>
          <input type="hidden" name="issuer" value={issuer} />
        </form>
      </div>
    </div>
  );
}

export default InvoicePage;
